<template>
  <div id="scroll-board">
    <Border class="title">实时订单</Border>
    <dv-loading v-if="!order.data.length">Loading...</dv-loading>
    <dv-scroll-board v-else :config="order"/>
  </div>
</template>

<script>
import Border from './border.vue'

export default {
  name: 'ScrollBoard',
  props: ['order'],
  components: {
    Border
  },
  data () {
    return {
      config: {
        header: ['时间', '订单编号', '金额', '用户'],
        data: [
          ['2019-07-01 19:25:00', '113-8756396-0885060', '$5.3', 'aa**@163.com'],
          ['2019-07-02 17:25:00', '113-8756396-0885060', '$13.22', 'aa**@163.com'],
          ['2019-07-03 16:25:00', '113-8756396-0885060', '$6.00', 'aa**@163.com'],
          ['2019-07-04 15:25:00', '113-8756396-0885060', '$2.43', 'aa**@163.com'],
          ['2019-07-05 14:25:00', '113-8756396-0885060', '$1.98', 'aa**@163.com'],
          ['2019-07-06 13:25:00', '113-8756396-0885060', '$3.23', 'aa**@163.com'],
          ['2019-07-07 12:25:00', '113-8756396-0885060', '$4.11', 'aa**@163.com'],
          ['2019-07-08 11:25:00', '113-8756396-0885060', '$2.00', 'aa**@163.com'],
          ['2019-07-09 10:25:00', '113-8756396-0885060', '$5.33', 'aa**@163.com'],
          ['2019-07-10 09:25:00', '113-8756396-0885060', '$3.99', 'aa**@163.com']
        ],
        columnWidth: [150, 170, 150, 150],
        align: ['center'],
        rowNum: 9,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  }
}
</script>

<style lang="less" scoped>
#scroll-board {
  width: 100%;
  box-sizing: border-box;
  margin-left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;
  font-size: 40px;



  .title {
    position: relative;
    font-size: 40px;
    line-height: 120px;
    width: 80px;
    padding: 0 50px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 2000px) {
  #scroll-board {

    font-size: 17px;



    .title {

      font-size: 17px;
      line-height: 51px;
      width: 34px;
      padding: 0 20px;
    }
  }
}
</style>
<style>
#scroll-board .row-item {
  font-size: 18px !important;
}
#scroll-board .header-item {
  font-size: 18px !important;
}
@media screen and (max-width: 2000px) {
  #scroll-board .row-item {
    font-size: 12px !important;
  }
  #scroll-board .header-item {
    font-size: 14px !important;
  }
}
</style>
